module.exports = __webpack_public_path__ + "img/theme12.0888587a.png";